import gql from 'graphql-tag';

const PURCHASE_ORDER_ITEM_DETAIL_FRAGMENT = gql`
	fragment purchaseOrderItem on PurchaseOrderItem {
		id
		purchaseOrder {
			id
		}
		warehouseProduct {
			id
			quantity
			product {
				id
				name
				imageUrl
				forceQuantityInUnits
			}
		}
		quantity
		originalQuantity
		stockDeliveryItem {
			id
			stockDelivery {
				id
				identifier
				sourceObj
			}
		}
	}
`;

export const GET_PURCHASE_ORDER_ITEM = gql`
	query($id: String) {
		getPurchaseOrderItem (id: $id) {
			...purchaseOrderItem
		}
	}
	${PURCHASE_ORDER_ITEM_DETAIL_FRAGMENT}
`;
